import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TOrderChecklistState } from './order-checklist.models';

export const getOrderChecklistState = (state: TPlani8State) => state.orderChecklistInfo;

export const getOrderChecklistInfo = createSelector(
  getOrderChecklistState,
  (state: TOrderChecklistState) => state.orderChecklistInfo,
);

export const getUserPaginationOption = createSelector(
  getOrderChecklistState,
  (state: TOrderChecklistState) => state.userPaginationOption,
);

export const getOrderChecklistSelectedFilters = createSelector(
  getOrderChecklistState,
  (state: TOrderChecklistState) => state.orderChecklistSelectedFilters,
);
